import { render, staticRenderFns } from "./SharedResponsibilityComponent.vue?vue&type=template&id=1b98f195&scoped=true"
import script from "./SharedResponsibilityComponent.vue?vue&type=script&lang=js"
export * from "./SharedResponsibilityComponent.vue?vue&type=script&lang=js"
import style0 from "./SharedResponsibilityComponent.vue?vue&type=style&index=0&id=1b98f195&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b98f195",
  null
  
)

export default component.exports